export default "__VITE_ASSET__CqGR1Mlf__"